export { Icon, IconProps } from './Icon'
